const state = {
  agencyId: undefined,
  businessId: undefined,
  purchaseId: undefined,
  is_new: false,
  destination: undefined,
  transferred_at: [],
  uploaded_at: []
};

const getters = {
  getAgencyId: state => state.agencyId,
  getBusinessId: state => state.businessId,
  getPurchaseId: state => state.purchaseId,
  getIsNew: state => state.is_new,
  getDestination: state => state.destination,
  getTransferredAt: state => state.transferred_at,
  getUploadedAt: state => state.uploaded_at
};

const mutations = {
  setAgencyId(state, value) {
    state.agencyId = value;
  },
  setBusinessId(state, value) {
    state.businessId = value;
  },
  setPurchaseId(state, value) {
    state.purchaseId = value;
  },
  setIsNew(state, value) {
    state.isNew = value;
  },
  setDestination(state, value) {
    state.destination = value;
  },
  setTransferredAt(state, dates) {
    state.transferred_at = dates;
  },
  setUploadedAt(state, value) {
    state.uploaded_at = value;
  }
};

const actions = {
  saveAgencyId(context, value) {
    context.commit("setAgencyId", value);
  },
  saveBusinessId(context, value) {
    context.commit("setBusinessId", value);
  },
  savePurchaseId(context, value) {
    context.commit("setPurchaseId", value);
  },
  saveIsNew(context, value) {
    context.commit("setIsNew", value);
  },
  saveDestination(context, value) {
    context.commit("setDestination", value);
  },
  saveTransferredAt(context, dates) {
    context.commit("setTransferredAt", dates);
  },
  saveUploadedAt(context, dates) {
    context.commit("setUploadedAt", dates);
  },
  saveFilter(context, data) {
    context.commit("setAgencyId", data.agencyId || undefined);
    context.commit("setBusinessId", data.businessId || undefined);
    context.commit("setPurchaseId", data.purchaseId || undefined);
    context.commit("setIsNew", data.is_new || false);
    context.commit("setDestination", data.destination || "");
    context.commit("setTransferredAt", data.transferred_at || []);
    context.commit("setUploadedAt", data.uploaded_at || []);
  },
  clearFilter(context) {
    context.commit("setAgencyId", undefined);
    context.commit("setBusinessId", undefined);
    context.commit("setPurchaseId", undefined);
    context.commit("setIsNew", false);
    context.commit("setDestination", "");
    context.commit("setTransferredAt", []);
    context.commit("setUploadedAt", []);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
